import styled from 'styled-components'

export const Container = styled.label`
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  & p {
    margin: 0;
  }
`
